// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"38":"479541d5a6a06b18","266":"7e745539674aae29","453":"4640009f668afea6"}[chunkId] + ".chunk.js";
};